import { render, staticRenderFns } from "./mainConfiguration.template.vue?vue&type=template&id=2e82b24e&scoped=true&"
var script = {}
import style0 from "./mainConfiguration.template.vue?vue&type=style&index=0&id=2e82b24e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82b24e",
  null
  
)

export default component.exports